import { cn } from '@/utils/cn';

/** Floor so resizable/shrinking columns stay usable (grip + a snippet of text). */
export const RETAIL_MIN_COLUMN_WIDTH_PX = 96;

/**
 * Default vertical cap for Retail tables. This is a max-height, not a height:
 * short tables stay compact; long tables stop growing and scroll inside.
 */
export const RETAIL_TABLE_MAX_HEIGHT = '28rem';
export const RETAIL_TABLE_MAX_HEIGHT_CLASS = 'max-h-[28rem]';

/**
 * Outer clip + card chrome. Horizontal overflow belongs on `RETAIL_TABLE_SCROLL_CLASS`,
 * not on the page.
 */
export const RETAIL_TABLE_FRAME_CLASS =
  'max-w-full min-w-0 overflow-hidden rounded-xl border border-border bg-surface shadow-md';

/**
 * Retail-only scrollport (`retail-table-scroll` in index.css).
 */
export const RETAIL_TABLE_SCROLL_CLASS =
  'retail-table-scroll custom-scrollbar max-h-[28rem] max-w-full min-w-0 overflow-x-auto overflow-y-auto';

export const RETAIL_TABLE_CLASS = 'w-max min-w-full border-collapse text-left';

export const RETAIL_TABLE_HEAD_CLASS =
  'sticky top-0 z-10 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap bg-surface-header px-3 py-2.5 text-label-md font-semibold uppercase tracking-[0.12em] text-foreground-subtle';

export const RETAIL_TABLE_CELL_CLASS =
  'min-w-0 overflow-hidden text-ellipsis whitespace-nowrap align-middle px-3 py-2.5 text-foreground';

/** Opt out of nowrap for intentionally multi-line cells (product identity, stacked metrics). */
export const RETAIL_TABLE_CELL_WRAP_CLASS = 'app-table-cell-wrap whitespace-normal';

export const RETAIL_IDENTITY_COLUMN_WIDTH = '18rem';
export const RETAIL_IDENTITY_CELL_CLASS =
  'app-table-identity-cell app-table-cell-wrap w-[18rem] min-w-0 whitespace-normal align-middle';

export const RETAIL_IDENTITY_FILL_CELL_CLASS = 'app-table-identity-fill';

export const RETAIL_TRAILING_METRIC_CELL_CLASS = 'app-table-trailing-metric';

export const RETAIL_NUMERIC_CELL_CLASS = 'min-w-[6.5rem] text-right tabular-nums';

export function retailTableFrameClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_FRAME_CLASS, ...extra);
}

export function retailTableScrollClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_SCROLL_CLASS, ...extra);
}

export function retailTableClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_CLASS, ...extra);
}

export function retailTableHeadClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_HEAD_CLASS, ...extra);
}

export function retailTableCellClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_CELL_CLASS, ...extra);
}

export function retailIdentityCellClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_IDENTITY_CELL_CLASS, ...extra);
}

export function retailNumericCellClass(...extra: Array<string | false | null | undefined>) {
  return cn(RETAIL_TABLE_CELL_CLASS, RETAIL_NUMERIC_CELL_CLASS, ...extra);
}
